
import React, { Component, Fragment } from 'react';

import keyboardShortcut from '../../../../../modules/keyboardshortcut/keyboardshortcut';
import {
    ACTION_SHORTCUT_TRIGGERED,
    createShortcutEvent,
    createToolbarEvent,
    sendAnalytics
} from '../../../analytics';
import { getToolbarButtons } from '../../../base/config';
import { isToolbarButtonEnabled } from '../../../base/config/functions.web';
import { openDialog, toggleDialog } from '../../../base/dialog';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n';
import JitsiMeetJS from '../../../base/lib-jitsi-meet';
import {
    getLocalParticipant,
    getParticipantCount,
    haveParticipantWithScreenSharingFeature,
    raiseHand,
    PARTICIPANT_ROLE
} from '../../../base/participants';
import { connect } from '../../../base/redux';
import { getLocalVideoTrack } from '../../../base/tracks';
import { toggleChat } from '../../../chat';
import { ChatButton } from '../../../chat/components';
import { DominantSpeakerName } from '../../../display-name';
import { EmbedMeetingButton } from '../../../embed-meeting';
import { SharedDocumentButton } from '../../../etherpad';
import { FeedbackButton } from '../../../feedback';
import { InviteButton } from '../../../invite/components/add-people-dialog';
import { isVpaasMeeting } from '../../../jaas/functions';
import { KeyboardShortcutsButton } from '../../../keyboard-shortcuts';
import { LocalRecordingButton } from '../../../local-recording';
import {
    close as closeParticipantsPane,
    open as openParticipantsPane
} from '../../../participants-pane/actions';
import ParticipantsPaneButton from '../../../participants-pane/components/web/ParticipantsPaneButton';
import { getParticipantsPaneOpen } from '../../../participants-pane/functions';
import { addReactionToBuffer } from '../../../reactions/actions.any';
import { ReactionsMenuButton } from '../../../reactions/components';
import { REACTIONS } from '../../../reactions/constants';
import { isReactionsEnabled } from '../../../reactions/functions.any';
import {
    LiveStreamButton,
    RecordButton
} from '../../../recording';
import {
    isScreenAudioSupported,
    isScreenVideoShared,
    ShareAudioButton,
    startScreenShareFlow
} from '../../../screen-share/';
// import SecurityDialogButton from '../../../security/components/security-dialog/SecurityDialogButton';
import { SettingsButton } from '../../../settings';
import { SharedVideoButton } from '../../../shared-video/components';
import { SpeakerStatsButton } from '../../../speaker-stats';
import {
    ClosedCaptionButton
} from '../../../subtitles';
import {
    TileViewButton,
    shouldDisplayTileView,
    toggleTileView
} from '../../../video-layout';
import { VideoQualityDialog, VideoQualityButton } from '../../../video-quality/components';
import { VideoBackgroundButton } from '../../../virtual-background';
import { toggleBackgroundEffect } from '../../../virtual-background/actions';
import { VIRTUAL_BACKGROUND_TYPE } from '../../../virtual-background/constants';
import {
    setFullScreen,
    setOverflowMenuVisible,
    setToolbarHovered,
    showToolbox
} from '../../actions';
import { THRESHOLDS, NOT_APPLICABLE } from '../../constants';
import { isToolboxVisible } from '../../functions';
import DownloadButton from '../DownloadButton';
import HangupButton from '../RPC_HangupButton';
import HelpButton from '../HelpButton';
import MuteEveryoneButton from '../MuteEveryoneButton';
import MuteEveryonesVideoButton from '../MuteEveryonesVideoButton';

import AudioSettingsButton from './AudioSettingsButton';
import FullscreenButton from './FullscreenButton';
import OverflowMenuButton from './OverflowMenuButton';
import ProfileButton from './ProfileButton';
import RaiseHandButton from './RaiseHandButton';
import Separator from './Separator';
import ShareDesktopButton from './ShareDesktopButton';
import ToggleCameraButton from './ToggleCameraButton';
import VideoSettingsButton from './VideoSettingsButton';
import ToolbarButton from './ToolbarButton';

// added by naveen
import {
    IconMenuDown,
    IconMenuUp,
    IconMessage,
    IconPeople,
    IconWhiteboard,
    IconShareDesktop,
    IconFullScreen,
    IconExitFullScreen,
    IconPresent
} from '../../../base/icons';
import InlineDialog from '@atlaskit/inline-dialog';
import { MeetingContent } from '../../../invite/components/add-people-dialog/web';
import { getConferenceName } from '../../../base/conference';
import { Toolbox, _connect } from './Toolbox';
import { ChatCounter } from '../../../chat';
import PresentMenuButton from './PresentMenuButton';
import MoreMenuButton from './MoreMenuButton';
import { OverflowMenuItem } from '../../../base/toolbox/components';
import { checkBlurSupport } from '../../../virtual-background/functions';
import { WHITEBOARD_CLOSE_COMMAND, WHITEBOARD_OPEN_COMMAND } from '../../../whiteboard/constants'
import { stopSharedVideo } from '../../../shared-video/actions.any';

class RPC_Toolbox extends Toolbox {
    constructor(props) {
        super(props);
        this.state = {
            ...super.state,
            _meetingDetailsVisible: false
        }
        this._onSetMoreVisible = this._onSetMoreVisible.bind(this);
        this._onSetPresentVisible = this._onSetPresentVisible.bind(this);
        this._onToolbarToggleWhiteboard = this._onToolbarToggleWhiteboard.bind(this);
        this._onToolbarStopShare = this._onToolbarStopShare.bind(this);
    }

    meetingDetails () {
        return (
            <MeetingContent />
        );
    }

    _onToolbarToggleWhiteboard() {
        this._closeOverflowMenuIfOpen();
        this._closeMoreMenuIfOpen();
        this._closePresentMenuIfOpen();
        this._doToggleWhiteboard();
    }

    _onToolbarStopShare() {
        const { _whiteboardOpen, _screenSharing, _shared_video, dispatch } = this.props;
        if(_whiteboardOpen) { this._doToggleWhiteboard(); }
        if(_screenSharing) { this._doToggleScreenshare(false); }
        if(_shared_video) { dispatch(stopSharedVideo()); }
    }
    
    _doToggleWhiteboard() {
        const { _whiteboardOpen, _conference, dispatch } = this.props;
        if(!_whiteboardOpen) {
            window.isWhiteboardByMe = true
            _conference.sendCommandOnce(WHITEBOARD_OPEN_COMMAND, { tp: Date.now() });
        } else {
            _conference.sendCommandOnce(WHITEBOARD_CLOSE_COMMAND, { value: window.isWhiteboardByMe, tp: Date.now() });
        }
    }

    toggleMeetingPopover = () => {
        this.setState({
            _meetingDetailsVisible: !this.state._meetingDetailsVisible
        })
    }
    _closePresentMenuIfOpen() {
        const { dispatch, _presentMenuVisible } = this.props;
        _presentMenuVisible && dispatch({
            type: 'SET_PRESENT_MENU_VISIBLE',
            visible: false
        });
    }
    _closeMoreMenuIfOpen() {
        const { dispatch, _moreMenuVisible } = this.props;
        _moreMenuVisible && dispatch({
            type: 'SET_MORE_MENU_VISIBLE',
            visible: false
        });
    }
    _onSetPresentVisible(visible) {
        this.props.dispatch({
            type: 'SET_PRESENT_MENU_VISIBLE',
            visible
        });
    }
    _onSetMoreVisible(visible) {
        this.props.dispatch({
            type: 'SET_MORE_MENU_VISIBLE',
            visible
        });
    }

    _renderPresentMenuContent(additionalButtons: Array<React$Element<any>>) {
        const {
            _feedbackConfigured,
            _fullScreen,
            _isMobile,
            _screenSharing,
            _whiteboardOpen,
            t
        } = this.props;
        return [
            <OverflowMenuItem
                    accessibilityLabel = { 'Toggle Whiteboard' }
                    icon = { IconWhiteboard }
                    iconId = 'white-board'
                    key = 'whiteboard'
                    onClick = { this._onToolbarToggleWhiteboard }
                    text = { _whiteboardOpen ? 'Close Whiteboard' : 'Whiteboard' } />,
            <OverflowMenuItem
                    accessibilityLabel = { t('toolbar.accessibilityLabel.shareYourScreen') }
                    icon = { IconShareDesktop }
                    iconId = 'share-desktop'
                    key = 'desktop'
                    onClick = { this._onToolbarToggleScreenshare }
                    text = { t(`toolbar.${_screenSharing ? 'stopScreenSharing' : 'startScreenSharing'}`) } />
        ];
    }
    
    _renderMoreMenuContent(additionalButtons: Array<React$Element<any>>) {
        const {
            _fullScreen,
            _screenSharing,
            t
        } = this.props;
        return [
            <LiveStreamButton
                    key = 'livestreaming'
                    showLabel = { true } />,
            <SharedVideoButton
                    key = 'sharedvideo'
                    showLabel = { true } />,
            <VideoBackgroundButton
                    key = { 'select-background' }
                    showLabel = { true }
                    visible = { !_screenSharing && checkBlurSupport() } />,
            <OverflowMenuItem
                    accessibilityLabel = { t('toolbar.accessibilityLabel.fullScreen') }
                    icon = { _fullScreen ? IconExitFullScreen : IconFullScreen }
                    key = 'fullscreen'
                    onClick = { this._onToolbarToggleFullScreen }
                    text = { _fullScreen ? t('toolbar.exitFullScreen') : t('toolbar.enterFullScreen') } />,
            <SettingsButton
                    key = 'settings'
                    showLabel = { true } />,
        ];
    }

    _renderToolboxContent() {
        const {
            _isMobile,
            _overflowMenuVisible,
            _toolbarButtons,
            showDominantSpeakerName,
            _subject,
            t,
            _reactionsEnabled,
            _isModerator,
            _raisedHand,
            participantsCount,
            raiseHandCount,
            _screenSharing,
            _whiteboardOpen,
            _shared_video,
            _presentMenuVisible,
            _moreMenuVisible
        } = this.props;

        const toolbarAccLabel = 'toolbar.accessibilityLabel.moreActionsMenu';
        const containerClassName = `toolbox-content${_isMobile ? ' toolbox-content-mobile' : ''}`;

        const { mainMenuButtons, overflowMenuButtons } = this._getVisibleButtons();

        const Microphone = mainMenuButtons[0].Content;
        const Camera = mainMenuButtons[1].Content;
        const Chat = mainMenuButtons[3].Content;
        const RaiseHand = mainMenuButtons[4].Content;
        const ParticipantsPane = mainMenuButtons[5]?.Content;

        return (
            <div className = { containerClassName }>
                <div
                    className = 'toolbox-content-wrapper'
                    onFocus = { this._onTabIn }
                    { ...(_isMobile ? {} : {
                        onMouseOut: this._onMouseOut,
                        onMouseOver: this._onMouseOver
                    }) }>
                    <div className= 'toolbox-meeting-details'>
                        <InlineDialog onClose={ this.toggleMeetingPopover } content={ this.meetingDetails() } isOpen={ this.state._meetingDetailsVisible }>
                            <div className="meeting-title" onClick={this.toggleMeetingPopover}>
                                { _subject }
                                { this.state._meetingDetailsVisible ?
                                    <a><IconMenuUp /></a> : <a><IconMenuDown /></a>
                                }
                            </div>
                        </InlineDialog>
                        <RecordButton
                            key = 'record'
                            showLabel = { true } />
                    </div>

                    { showDominantSpeakerName && <DominantSpeakerName /> }

                    <div className = 'toolbox-content-items'>

                        <Microphone
                            { ...mainMenuButtons[0] }
                            key = { mainMenuButtons[0].key } />

                        <HangupButton
                            customClass = 'hangup-button'
                            key = 'hangup-button'
                            visible = { isToolbarButtonEnabled('hangup', _toolbarButtons) } />

                        <Camera
                            { ...mainMenuButtons[1] }
                            key = { mainMenuButtons[1].key } />
                    </div>

                    <div className="toolbar-right">
                        { !_isModerator && <div className="action-button" onClick = { this._onToolbarToggleRaiseHand }>
                            <div
                                className = 'toolbar-button-with-badge'
                                key = 'raisehandcontainer'>
                                <RaiseHand
                                    { ...mainMenuButtons[4] }
                                    key = { mainMenuButtons[4].key } />
                            </div>
                            <span>{ _raisedHand ? 'Lower Hand' : 'Raise Hand' }</span>
                        </div> }
                        { mainMenuButtons[5] && <div className="action-button" onClick = { mainMenuButtons[5].handleClick }>
                            <div
                                className = 'toolbar-button-with-badge'
                                key = 'peoplecontainer'>
                                <ParticipantsPane
                                    { ...mainMenuButtons[5] }
                                    key = { mainMenuButtons[5].key } />
                                <span className="badge-round">
                                    <span>{ raiseHandCount ? raiseHandCount : '' }</span>
                                </span>
                            </div>
                            <span>People</span>
                        </div> }
                        <div className="action-button" onClick = { mainMenuButtons[3].handleClick }>
                            <div
                                className = 'toolbar-button-with-badge'
                                key = 'chatcontainer' onClick = { mainMenuButtons[3].handleClick } style={{ pointerEvents: 'none' }}>
                                <Chat
                                    { ...mainMenuButtons[3] }
                                    key = { mainMenuButtons[3].key } />
                                <ChatCounter />
                            </div>
                            <span>Chat</span>
                        </div>
                        { !_screenSharing && !_whiteboardOpen && !_shared_video && <PresentMenuButton
                            isOpen = { _presentMenuVisible }
                            onVisibilityChange = { this._onSetPresentVisible }>
                            <ul
                                aria-label = { t(toolbarAccLabel) }
                                className = 'overflow-menu' onClick={ () => { this._onSetPresentVisible(false); } }>
                                { this._renderPresentMenuContent() }
                            </ul>
                        </PresentMenuButton>}
                        { (_screenSharing || _whiteboardOpen || _shared_video) && <div className="action-button" onClick = { this._onToolbarStopShare }>
                            <div
                                className = 'toolbar-button-with-badge'
                                key = 'stopsharingcontainer'>
                                <ToolbarButton
                                    accessibilityLabel = { 'Stop Sharing' }
                                    icon = { IconPresent }
                                    key = 'stopshare'
                                    toggled = { _screenSharing || _whiteboardOpen }
                                    tooltip = { 'Stop Sharing' } />
                                <ChatCounter />
                            </div>
                            <span>Stop Share</span>
                        </div> }
                        <MoreMenuButton
                            isOpen = { _moreMenuVisible }
                            onVisibilityChange = { this._onSetMoreVisible }>
                            <ul
                                aria-label = { t(toolbarAccLabel) }
                                className = 'overflow-menu' onClick={ () => { this._onSetMoreVisible(false); } }>
                                { this._renderMoreMenuContent() }
                            </ul>
                        </MoreMenuButton>
                    </div>
                </div>
            </div>
        );
    }
}

function _mapStateToProps(state) {
    const { moreMenuVisible, presentMenuVisible } = state['features/toolbox'];
    const { length: participantsCount, raisedHandsQueue } = state['features/base/participants'];
    const localParticipant = getLocalParticipant(state);
    const _whiteboardOpen = state['features/whiteboard'].isOpen;
    const _chatOpen = state['features/chat'].isOpen;
    const _participantsPaneOpen = state['features/participants-pane'].isOpen;
    const { ownerId: shared_video } = state['features/shared-video'];
    const raisedHandsQueueSort = raisedHandsQueue.filter((value, index, self) => index === self.findIndex((val) => (val.id === value.id)));

    return {
        _subject: getConferenceName(state),
        _whiteboardOpen,
        _moreMenuVisible: moreMenuVisible,
        _presentMenuVisible: presentMenuVisible,
        _isModerator: Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR),
        participantsCount: participantsCount,
        raiseHandCount: raisedHandsQueueSort.length,
        _visible: !_chatOpen && !_participantsPaneOpen && (_whiteboardOpen || isToolboxVisible(state)),
        _shared_video: shared_video == localParticipant.id
    };
}

export default translate(_connect(connect(_mapStateToProps)(RPC_Toolbox)));
